const abortControllers = new Map();

export const addAbortController = (key, controller) => {
  abortControllers.set(key, controller);
};

export const removeAbortController = (key) => {
  abortControllers.delete(key);
};

export const abortRequest = (key) => {
  if (abortControllers.has(key)) {
    abortControllers.get(key).abort();
    abortControllers.delete(key);
  }
};

export const abortAllRequests = async () => {
  const abortPromises = Array.from(abortControllers.values()).map(controller => {
    return new Promise((resolve) => {
      if (controller) {
        controller.abort?.();
      }
      resolve();
    });
  });
  await Promise.all(abortPromises);
  abortControllers.clear();
};